import React from 'react';
import { Linkedin, Mail, Printer } from 'lucide-react';

/** Twitter/X icon (simple X) */
function TwitterIcon({ size = 20, className }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" className={className}>
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
  );
}

export function ShareSidebar({ url, title, description }) {
  const encodedUrl = encodeURIComponent(url || (typeof window !== 'undefined' ? window.location.href : ''));
  const encodedTitle = encodeURIComponent(title || '');
  const encodedText = encodeURIComponent(description || title || '');

  const shareLinks = [
    {
      label: 'Share on LinkedIn',
      href: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
      icon: Linkedin,
    },
    {
      label: 'Share on X (Twitter)',
      href: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedText}`,
      icon: TwitterIcon,
    },
    {
      label: 'Share via Email',
      href: `mailto:?subject=${encodedTitle}&body=${encodedText}%0A%0A${encodedUrl}`,
      icon: Mail,
    },
  ];

  const handlePrint = () => window.print();

  return (
    <aside className="hidden md:flex flex-col items-center gap-4 pt-24 pr-4" aria-label="Share article">
      {shareLinks.map(({ label, href, icon: Icon }) => (
        <a
          key={label}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={label}
          className="w-10 h-10 flex items-center justify-center rounded-full border border-border text-foreground hover:border-primary hover:text-primary transition-colors"
        >
          <Icon size={18} />
        </a>
      ))}
      <button
        type="button"
        onClick={handlePrint}
        aria-label="Print article"
        className="w-10 h-10 flex items-center justify-center rounded-full border border-border text-foreground hover:border-primary hover:text-primary transition-colors"
      >
        <Printer size={18} />
      </button>
    </aside>
  );
}
